import * as React from 'react'
import { Field } from 'formik'

import QuestionSkeleton from '../question-skeleton'
import { QuestionFormBaseProps } from '../../../../types'
import { StyledKeyboardDatePicker } from '../../../../../formik/components/StyledFormikDateTimePickers'
import { US_DATE_FORMAT } from '../../../../../utils/format'

interface DateOfBirthQuestionProps extends QuestionFormBaseProps {
  fieldName: string
}

const DateOfBirthQuestion = (props: DateOfBirthQuestionProps) => {
  const { item, error, fieldName, readonly } = props

  if (item.disabled) {
    return null
  }

  return (
    <QuestionSkeleton questionTitle={item.question} isRequired={item.isRequired} error={error}>
      <Field
        component={StyledKeyboardDatePicker}
        name={fieldName}
        label="Date of Birth"
        placeholder={US_DATE_FORMAT}
        format={US_DATE_FORMAT}
        inputVariant="outlined"
        disabled={readonly}
        clearable
      />
    </QuestionSkeleton>
  )
}

export default DateOfBirthQuestion
